<style scoped>
.chips-container {
  border-style: inset;
  min-height: 56px;
  padding: 8px;
}
.chip-item {
  margin: 4px;
}
.no-padding {
  border-radius: 0px;
  padding: 0px;
}
</style>

<template>
    <div v-if="!simpleMode">
      <v-popover
        offset="16"
        trigger="hover"
        placement="top"
        popoverInnerClass="no-padding"
        :disabled="!isImage(attachment.mimetype)"
        >
        <mu-chip class="chip-item" @click="onClickDownload" :delete="!isSubmitted" @delete="onDelete">
          {{attachment.filename}}
        </mu-chip>
        <template slot="popover">
          <img v-if="isImage(attachment.mimetype)" style="max-width: 100%;" :src="blob"/>
        </template>
      </v-popover>
    </div>
    <span v-else>
      <v-popover
        offset="16"
        trigger="hover"
        placement="top"
        popoverInnerClass="no-padding"
        :disabled="!isImage(attachment.mimetype)"
        >
        <mu-icon size="12" value="insert_drive_file"></mu-icon>
        <a href="" @click.stop.prevent="onClickDownload">
          {{attachment.filename}}
        </a>
        <template slot="popover">
          <img v-if="isImage(attachment.mimetype)" style="max-width: 100%;" :src="blob"/>
        </template>
      </v-popover>
    </span>
  </div>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import axios from "axios";

import { VPopover } from 'v-tooltip'

export default {
  name: 'AttachmentItem',
  components: {
    VPopover
  },
  props: {
    simpleMode: {
      type: Boolean,
      default: false
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      // Object
      blob: null,
    }
  },
  computed: {
  },
  watch: {
    attachment: {
      handler(newValue) {
        this.onFetchBlob();
      },
      deep: true
    }
  },
  created() {
    
  },
  mounted() {
    this.$i18n.add('en', langEn);
    this.$i18n.add('zh', langZh);
    this.onFetchBlob();
  },
  methods: {
    onFetchBlob() {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=' + this.attachment.path,  // apiUrl is the server api url and path is the path of file to download in server
        headers: {
          token: this.$store.state.auth.token
        },
        responseType: 'arraybuffer' // Important attribute for response to create a blob for download
      }).then(res => {
        let b = new Blob([res.data], { type: this.attachment.mimetype }); // Create a blob, mimetype is a variable to indicate the type of file, such as "text/plain" for json files
        let a = window.URL.createObjectURL(b)
        this.blob = a;
      });
    },
    onClickDownload() {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=' + this.attachment.path,  // apiUrl is the server api url and path is the path of file to download in server
        headers: {
          token: this.$store.state.auth.token
        },
        responseType: 'arraybuffer' // Important attribute for response to create a blob for download
      }).then(res => {
        let b = new Blob([res.data], { type: this.attachment.mimetype }); // Create a blob, mimetype is a variable to indicate the type of file, such as "text/plain" for json files
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(b);
        link.download = this.attachment.filename;
        link.click();
      });
      
    },
    onDelete() {
      this.$emit('onDelete');
    },
    
    isImage(type) {
      return type === 'image/jpeg' || type === 'image/png';
    },
  },
}
</script>
